/* eslint-disable react/no-multi-comp */

import PropTypes from 'prop-types';
import {connect} from 'react-redux';
import React, {Component} from 'react';

class Audio extends Component {

    player = null;

    constructor(props) {
        super(props);

        this.state = {
            playing: false,
        };
    }

    togglePlay = () => {
        if (!this.player) return;

        const {playing} = this.state;

        if (playing) this.player.pause();
        else this.player.play();
    };

    onPlay = event => {
        const {onPlay} = this.props;
        this.setState({playing: true});
        return onPlay && onPlay(event);
    };

    onPause = event => {
        const {onPause} = this.props;
        this.setState({playing: false});
        return onPause && onPause(event);
    };

    render() {
        const {url, ...props} = this.props;
        const {playing} = this.state;

        return (
            <div className="audio-container">
                <i className="material-icons play-button" onClick={this.togglePlay}>
                    {playing ? 'pause' : 'play_arrow'}
                </i>

                <audio
                    style={{width: '100%'}}
                    {...props}
                    ref={node => { this.player = node; }}
                    onPlay={this.onPlay}
                    onPause={this.onPause}
                    src={url}
                    controlsList="nodownload noplaybackrate"
                />
            </div>
        );
    }
}

const Image = ({url, name}) => <img src={url} alt={name} />;

// playsInline keeps video embedded on iOS instead of the native fullscreen player
// (native app must set WKWebView.allowsInlineMediaPlayback = true for this to take effect)
const Video = ({url, ...props}) => (
    <video
        {...props}
        src={screen.width < 1024 ? url.low : url.high}
        controlsList="nodownload"
    />
);

const MediaPropTypes = {
    url: PropTypes.oneOfType([
        PropTypes.string,
        PropTypes.shape({
            low: PropTypes.string,
            high: PropTypes.string,
        }),
    ]).isRequired,
    controls: PropTypes.bool,
    autoPlay: PropTypes.bool,
};

const MediaEventPropTypes = {
    onPlay: PropTypes.func,
    onPause: PropTypes.func,
};

Audio.propTypes = {
    ...MediaPropTypes,
    ...MediaEventPropTypes,
};

Image.propTypes = {
    ...MediaPropTypes,
    name: PropTypes.string.isRequired,
};

Video.propTypes = {
    ...MediaPropTypes,
    ...MediaEventPropTypes,
};

export const MediaTypes = {
    audio: Audio,
    image: Image,
    video: Video,
};

class MediaElement extends Component {

    constructor(props) {
        super(props);

        const {seekable} = this.props;

        if (!seekable) {
            this.state = {
                currentTime: 0,
            };
        }
    }

    render() {
        const {type, seekable, onTimeUpdate, onSeeking, onFinish, dispatch, ...props} = this.props;

        const Node = MediaTypes[type];

        return (
            <Node
                {...props}
                onTimeUpdate={seekable ? onTimeUpdate : this.onTimeUpdate}
                onSeeking={seekable ? onSeeking : this.onSeeking}
                onPause={this.onPause}
                onEnded={this.onFinish}
            />
        );
    }

    onTimeUpdate = event => {
        const target = event.currentTarget;

        if (!target.seeking) {
            this.setState({currentTime: target.currentTime});
            if (typeof this.props.onTimeUpdate === 'function') this.props.onTimeUpdate(event);
        }
    };

    onSeeking = event => {
        const target = event.currentTarget;
        const delta = target.currentTime - this.state.currentTime;

        if (delta) {
            target.currentTime = this.state.currentTime;
        }

        if (typeof this.props.onSeeking === 'function') this.props.onSeeking(event);
    };

    onPause = event => {
        const target = event.currentTarget;
        if (typeof this.props.onSeeking === 'function' && !target.seeking) this.props.onPause(event);
    }

    onFinish = event => {
        if (typeof this.props.onFinish === 'function') this.props.onFinish(event);
    }
}

MediaElement.propTypes = {
    type: PropTypes.string.isRequired,
    seekable: PropTypes.bool,
    onTimeUpdate: PropTypes.func,
    onSeeking: PropTypes.func,
    onPause: PropTypes.func,
    onFinish: PropTypes.func,
};

MediaElement.defaultProps = {
    seekable: true,
    onTimeUpdate: null,
    onSeeking: null,
    onPause: null,
    onFinish: null,
};

const mapStateToProps = ({media}, {url}) => {
    if (media) {
        const {local} = media[url] || {};

        if (local) return {url: local};
    }

    return {url};
};

export default connect(mapStateToProps)(MediaElement);



// WEBPACK FOOTER //
// ./scripts/components/MediaElement.js